// F12 unsaved changes: one registry of changed forms (dirty_form_controller.ts) and one set of guards, so N changed
// forms ask once. Guards: leaving the page (Turbo visit, unload), a link or form that reloads a frame holding a changed
// form (card „Zrušit“, sort/page links of a hub list), and closing the form modal (modal_controller.ts).
const dirty = new Set<HTMLFormElement>()
let message = ''
let installed = false

export function markDirty(form: HTMLFormElement, text: string): void {
  dirty.add(form)
  message = text
  install()
}

export function markClean(form: HTMLFormElement): void {
  dirty.delete(form)
}

// Asks once when a changed form inside `container` (default: the whole page) would be lost; true = go on.
export function confirmDiscard(container: Node = document, except?: HTMLFormElement): boolean {
  const lost = [...dirty].filter((form) => form !== except && form.isConnected && container.contains(form))
  if (lost.length === 0) return true
  if (!window.confirm(message)) return false
  lost.forEach((form) => dirty.delete(form))
  return true
}

// The frame a link or form loads into (Turbo's rules: data-turbo-frame, else the enclosing frame or its target).
function targetFrame(element: Element): Element | null {
  const named = element.closest('[data-turbo-frame]')?.getAttribute('data-turbo-frame')
  if (named === '_top') return null
  if (named) return document.getElementById(named)
  const frame = element.closest('turbo-frame')
  const target = frame?.getAttribute('target')
  if (target === '_top') return null
  return target ? document.getElementById(target) : frame
}

function guard(event: Event, element: Element | null, except?: HTMLFormElement): void {
  if (!element || element.closest('[data-turbo="false"]')) return
  const frame = targetFrame(element)
  if (frame && !confirmDiscard(frame, except)) {
    event.preventDefault()
    event.stopImmediatePropagation()
  }
}

function install(): void {
  if (installed) return
  installed = true
  window.addEventListener('beforeunload', (event) => {
    if ([...dirty].some((form) => form.isConnected)) event.preventDefault()
  })
  document.addEventListener('turbo:before-visit', (event) => {
    if (!confirmDiscard()) event.preventDefault()
  })
  // Capture phase: before Turbo's own click/submit handlers, which skip prevented events.
  document.addEventListener('click', (event) => {
    if (event.target instanceof Element) guard(event, event.target.closest('a[href]'))
  }, true)
  document.addEventListener('submit', (event) => {
    if (event.target instanceof HTMLFormElement) guard(event, event.target, event.target)
  }, true)
}
